var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "title": "Signature",
      "size": "lg",
      "centered": "",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.closeDialog
    },
    model: {
      value: _vm.isOpen,
      callback: function callback($$v) {
        _vm.isOpen = $$v;
      },
      expression: "isOpen"
    }
  }, [_vm.loading ? _c('div', {
    staticClass: "loading-spinner"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _vm._e(), _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.signatureUrl,
      "alt": "Signature"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }